module.exports = __webpack_public_path__ + "static/media/logo-greenlight.9329bd92.png";